import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MacroTemplateService {
  private readonly templateSelectedSubject = new Subject<string>();

  get templateSelected$(): Observable<string> {
    return this.templateSelectedSubject.asObservable();
  }

  pushTemplate(template: string): void {
    if (!template || !template.trim()) {
      return;
    }
    this.templateSelectedSubject.next(template);
  }
}
